import React from 'react';
import ClassAssembly  from 'views/ClassAssembly4F';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;